<template>
  <PageBanner :obj="obj"></PageBanner>
  <router-view></router-view>
</template>

<script>
import image from "@/assets/image/page_banner.png";
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "About",
        en: "ABOUT HAIMA",
        link: "/about/js",
        image,
        list: [
          { name: "Company Introduction", link: "/about/js" },
          { name: "Honor", link: "/about/zz" },
          { name: "Development History", link: "/about/lc" },
          { name: "Cooperative Partner", link: "/about/hb" },
        ],
      },
    };
  },
  methods: {
    async aboutIndex() {
      let res = await service.aboutIndex();
      if (res.code == 1) {
        this.obj.cn = res.data.banner.name;
        this.obj.en = res.data.banner.eng_title;
        this.obj.image = this.$baseURL + res.data.banner.thumb;
      }
    },
  },
  created() {
    this.aboutIndex();
  },
};
</script>